import React from 'react';
import { Button, Stack, Typography } from '@mui/material';
import { PopupMessageWrapper } from './PopupMessageWrapper';

interface ChallengeSubmissionPromptProps {
    open: boolean;
    challengeName?: string;
    onYes: () => void;
    onNo: () => void;
}

export const ChallengeSubmissionPrompt = ({
    open,
    challengeName,
    onYes,
    onNo,
}: ChallengeSubmissionPromptProps) => {
    return (
        <PopupMessageWrapper open={open}>
            <Stack direction="column" spacing={2} sx={{ minWidth: 260, maxWidth: 400, textAlign: 'center' }}>
                <Typography variant="h6" sx={{ color: 'sepia.dark', fontWeight: 700 }}>
                    Challenge Submission
                </Typography>
                <Typography variant="body1" sx={{ color: 'sepia.main' }}>
                    {challengeName
                        ? `Do you need to report a submission for "${challengeName}"?`
                        : 'Do you need to report a challenge submission?'}
                </Typography>
                <Stack direction="row" spacing={2}> 
                    <Button
                        variant="contained"
                        onClick={onYes}
                        sx={{
                            flex: 1,
                            backgroundColor: 'primary.light',
                            color: 'white',
                            '&:hover': { backgroundColor: 'primary.main' },
                        }}
                    >
                        Yes
                    </Button>
                    <Button
                        variant="contained"
                        onClick={onNo}
                        sx={{
                            flex: 1,
                            backgroundColor: 'sepia.extraLight',
                            color: 'sepia.dark',
                            '&:hover': { backgroundColor: 'sepia.light', color: 'white' },
                        }}
                    >
                        No
                    </Button>
                </Stack>
                
            </Stack>
        </PopupMessageWrapper>
    );
};
